import '../forms/js/forms.js'
//import '../tabs/js/tabs.js';
//import '../themechanger/js/themechanger.js';

function loadJS(file) {
    // DOM: Create the script element
    var jsElm = document.createElement("script");
    // set the type attribute
    jsElm.type = "application/javascript";
    // make the script element load file
    jsElm.src = file;
    jsElm.defer = true;

    // finally insert the element to the body element in order to load the script
    document.body.appendChild(jsElm);
}
if ($(".tab")[0] || $(".tab2")[0] || $(".has-jQuery-tab").length > 0) {
    loadJS("/embrace/customizedjs/tabs.min.js?v=5&Cache-Control:max-age=86400");
}
if ($("[class*=slider]")[0]) {
    loadJS("/embrace/customizedjs/slider.min.js?v=2&Cache-Control:max-age=86400");
}
